import { isSuperAdminUser } from './userRoles';
import { firstAccessibleCorporatePath } from './corporatePageAccess';

export const EV_PAGE_FEATURE_FLAGS = ['page:ev-dashboard', 'page:ev-crisis-simulator'];

/** Platform pages visible to all authenticated user types (Super Admin, Corporate, Policy Maker). */
export const UNIVERSAL_PLATFORM_PATHS = new Set(['/intelligence-briefing']);

export const FEATURE_BY_PATH = {
  '/overview': 'page:overview',
  '/supply-markets': 'page:supply-markets',
  '/partners-risk': 'page:partners-risk',
  '/policy-intelligence': 'page:policy-intelligence',
  // '/global-resource-sentinel': 'page:global-resource-sentinel',
  // '/geoeconomic-ai': 'page:geoeconomic-ai',
  '/event-tracker': 'page:event-tracker',
  '/global-competitiveness': 'page:global-competitiveness',
  '/methodology': 'page:methodology',
  '/predictive-alerts': 'page:predictive-alerts',
  '/crisis-simulator': 'page:crisis-simulator',
  // '/company-risk-intelligence': 'page:company-risk-dashboard',
  '/ev-dashboard': 'page:ev-dashboard',
  '/ev_crisis_simulator': 'page:ev-crisis-simulator',
};

export function normalizeFeatures(features) {
  if (!Array.isArray(features)) {
    return [];
  }
  return features
    .map((f) => (typeof f === 'string' ? f.trim().toLowerCase() : ''))
    .filter(Boolean);
}

export function canAccessPath(pathname, features, user) {
  if (isSuperAdminUser(user)) {
    return true;
  }
  if (UNIVERSAL_PLATFORM_PATHS.has(pathname)) {
    return true;
  }
  const requiredFeature = FEATURE_BY_PATH[pathname];
  if (!requiredFeature) {
    return true;
  }
  if (user?.registration_type === 'corporate') {
    const normalizedFeatures = normalizeFeatures(features);
    if (EV_PAGE_FEATURE_FLAGS.includes(requiredFeature)) {
      return (
        normalizedFeatures.length > 0 && normalizedFeatures.includes(requiredFeature)
      );
    }
    return false;
  }
  const normalizedFeatures = normalizeFeatures(features);
  if (normalizedFeatures.length === 0) {
    return false;
  }
  return normalizedFeatures.includes(requiredFeature);
}

export function firstAccessiblePath(features, user) {
  if (isSuperAdminUser(user)) {
    return '/';
  }
  if (user?.registration_type === 'corporate') {
    return firstAccessibleCorporatePath(features, user);
  }
  const preferredOrder = ['/overview', '/supply-markets', '/'];
  for (const p of preferredOrder) {
    if (p === '/' || canAccessPath(p, features, user)) {
      return p;
    }
  }
  return '/';
}
